import { render, staticRenderFns } from "./BindingDevice.vue?vue&type=template&id=3606c67c&scoped=true&"
import script from "./BindingDevice.vue?vue&type=script&lang=js&"
export * from "./BindingDevice.vue?vue&type=script&lang=js&"
import style0 from "./BindingDevice.vue?vue&type=style&index=0&id=3606c67c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3606c67c",
  null
  
)

export default component.exports